export const sortByParam = (arr, param, direction) => {
  let newArr = [...arr]
  return newArr.sort((a, b) => {
    const directionVal = direction === 'desc' ? -1 : 1;
    if (a[param] > b[param]) return  directionVal
    else return directionVal * -1
  })
}
